'use client'
import { __awaiter } from '../_virtual/_tslib.js';
import { formatEther } from 'viem';
import { WalletConnectorBase } from '@dynamic-labs/wallet-connector-core';
import { DynamicError } from '@dynamic-labs/utils';
import { EthereumWallet, createViemUiTransaction } from '@dynamic-labs/ethereum-core';

class AccountAbstractionConnector extends WalletConnectorBase {
    constructor(opts) {
        super({ walletBook: opts.walletBook });
        this._isGasSponsorshipDisabled = false;
        this.evmNetworks = [];
        this.ChainWallet = EthereumWallet;
        this.isEmbeddedWallet = true;
        this.connectedChain = 'EVM';
        this.supportedChains = ['ETH', 'EVM'];
        this._walletUiUtils = opts.walletUiUtils;
        this.evmNetworks = opts.evmNetworks;
    }
    /**
     * Gets the EOA connector associated with this account abstraction wallet
     * @deprecated Use getEOAConnector with a specific smart contract wallet address instead
     */
    getEOAConnector() {
        return this.eoaConnector;
    }
    /**
     * Disables gas sponsorship for the next transaction
     */
    disableGasSponsorshipOnce() {
        this._isGasSponsorshipDisabled = true;
    }
    /**
     * Protected method to check if gas sponsorship is disabled
     */
    isGasSponsorshipDisabled() {
        return this._isGasSponsorshipDisabled;
    }
    /**
     * Gets the enabled networks
     */
    getEnabledNetworks() {
        return this.evmNetworks;
    }
    /**
     * Gets the signer for the current wallet
     */
    getSigner() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getWalletClient();
        });
    }
    /**
     * Gets the balance for an address
     */
    getBalance(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const publicClient = yield this.getPublicClient();
            if (!publicClient) {
                throw new DynamicError('No public client available');
            }
            const balance = yield publicClient.getBalance({ address });
            return formatEther(balance);
        });
    }
    /**
     * Validates that the expected wallet is active
     */
    validateActiveWallet(expectedAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentAddress = yield this.getAddress();
            if ((currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.toLowerCase()) !== expectedAddress.toLowerCase()) {
                throw new DynamicError('Invalid active wallet');
            }
        });
    }
    createUiTransaction(from) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateActiveWallet(from);
            const walletClient = this.getWalletClient();
            const publicClient = yield this.getPublicClient();
            if (!publicClient || !walletClient) {
                throw new DynamicError('No public client available');
            }
            return createViemUiTransaction({
                from,
                publicClient: publicClient,
                walletClient: walletClient,
            });
        });
    }
    getBlockExplorerUrlsForCurrentNetwork() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            return (_b = (_a = this.eoaConnector) === null || _a === void 0 ? void 0 : _a.getBlockExplorerUrlsForCurrentNetwork()) !== null && _b !== void 0 ? _b : [];
        });
    }
}

export { AccountAbstractionConnector };
